import { DocLinhaService } from './doc-linha-service'
import { api } from "../../plugins/api";

export * from './consulta-response'
export * from './doc-linha-service'
export * from './inclusao'
export * from './linha'
export * from './receita'
export * from './incluir-request'
export * from './atualizar-request'
export * from './remove-request'

export const doc_linha_sevice = new DocLinhaService(api)